const S = [
  ["What we collect", "Business account details, WhatsApp phone numbers, contact names, and message content sent or received through your connected WhatsApp Business Account via Meta's official Cloud API."],
  ["How we use it", "Only to deliver, store and display your WhatsApp conversations, run automated replies you configure, and show analytics. We never sell your data or use it for advertising."],
  ["Storage & security", "Data is stored on our own servers in India. Access tokens and secrets are encrypted at rest. Access is limited to your workspace members."],
  ["Third parties", "Messages are exchanged with Meta Platforms (WhatsApp Cloud API). AI replies run on our self-hosted model; no data is sent to outside AI services."],
  ["Retention & deletion", "Data is kept while your account is active. You can request deletion at any time — see /data-deletion. We delete data within 30 days of a verified request."],
  ["Contact", "support@route39.in"],
];
export default function Privacy() {
  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-slate-900">Chat360 Privacy Policy</h1>
        <p className="text-sm text-slate-500 mt-1">Attendy Technologies · Last updated: 26 October 2026</p>
        {S.map(([h, t]) => (
          <section key={h} className="mt-8">
            <h2 className="text-lg font-semibold text-slate-900">{h}</h2>
            <p className="text-slate-600 mt-2 leading-relaxed">{t}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
